import helpers from './mixin-helper'
import methods from './methods'
import L from 'leaflet'

function inside(point, vs) {
  let x = point.lat
  let y = point.lng

  let inside = false
  for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
    let xi = vs[i].lat
    let yi = vs[i].lng
    let xj = vs[j].lat
    let yj = vs[j].lng

    let intersect = ((yi > y) != (yj > y))
      && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
    if (intersect) {
      inside = !inside
    }
  }

  return inside
}

function specialInfo (event) {
  if (event === null) return []
  const table = []
  Object.keys(event.specialInfo).forEach(key => {
    let type = null
    if (/\[(.*)\]/.test(key)) {
      const match = key.match(/\[(.+?)\]/)
      type = match ? match[1] : null
    }

    if (Array.isArray(event.specialInfo[key])) {
      table.push({
        name: key,
        value: event.specialInfo[key].map(item =>
        {
          if (typeof item === 'object') {
            return Object.keys(item).reduce((obj, subkey) => {
              if (subkey === '_id') return obj
              return {
                ...obj,
                [subkey]: item[subkey]
              }
            }, {})
          } else {
            return item
          }
        }),
        key: key,
        type
      })
    } else if (typeof event.specialInfo[key] === 'object') {
      Object.keys(event.specialInfo[key]).forEach(subkey => {
        table.push({
          name: key + ' | ' + subkey,
          value: event.specialInfo[key][subkey],
          key: key + '_' + subkey,
          type
        })
      })
    } else {
      table.push({
        name: key,
        value: event.specialInfo[key],
        key: key,
        type
      })
    }
  })
  return table
}

function setPopupWrapper (marker, specialInfo, header = null, footer = null) {
  const getPopupTable = _getPopupTable.bind(this)

  const addListeners = (popup) => {
    if (!popup.getElement()) return

    const imgButtons = popup.getElement().getElementsByClassName('popup-img-button')
    Array.from(imgButtons).forEach(button => {
      const imageName = button.getAttribute('image')
      button.addEventListener('click', imageOnClick(this.$store.getters.projectPath + '/feedback/' + imageName))
    })

    const clipboardButtons = popup.getElement().getElementsByClassName('popup-clipboard-button')
    Array.from(clipboardButtons).forEach(button => {
      const data = button.getAttribute('data')
      button.addEventListener('click', clipboardOnClick(data))
    })
  }

  const removeListeners = (popup) => {
    if (!popup.getElement()) return

    const imgButtons = popup.getElement().getElementsByClassName('popup-img-button')
    Array.from(imgButtons).forEach(button => {
      const imageName = button.getAttribute('image')
      button.removeEventListener('click', imageOnClick(this.$store.getters.projectPath + '/feedback/' + imageName))
    })

    const clipboardButtons = popup.getElement().getElementsByClassName('popup-clipboard-button')
    Array.from(clipboardButtons).forEach(button => {
      const data = button.getAttribute('data')
      button.removeEventListener('click', clipboardOnClick(data))
    })
  }

  const imageOnClick = (path) => {
    return () => {
      return this.$eventBus.$emit('open-image-dialog', path)
    }
  }

  const clipboardOnClick = (data) => {
    const copyToClipboard = methods.copyToClipboard.bind(this)
    return () => copyToClipboard(data)
  }

  let popup = marker.getPopup()

  if (popup) {
    removeListeners(popup)
    marker.setPopupContent(getPopupTable(specialInfo, header, footer))
    addListeners(popup)
  } else {
    popup = L.popup({
      maxHeight: 450
    }).setContent(getPopupTable(specialInfo, header, footer))

    marker.bindPopup(popup)

    marker.on('popupopen', (e) => {
      addListeners(e.popup)
    })

    marker.on('popupclose', (e) => {
      removeListeners(e.popup)
    })
  }
}

function _getPopupTable (specialInfo, header = null, footer = null) {
  let body = ''

  if (Array.isArray(specialInfo)) {
    return specialInfo.reduce((all, item) => {
      return all += _getPopupTable.call(this, item, header, footer)
    }, body)
  }

  if (header) {
    body += header
  }

  let table = `
    <table style="table-layout: fixed; width: 300px">
    <tbody>
    <tr><td style="width: 35%" /><td style="width: 70%" /></tr>
  `
  Object.keys(specialInfo).forEach(key => {
    const match = key.match(/\[(.+?)\]/)
    const category = match ? match[1] : null

    switch (true) {
      case category === 'Image':
        table += _imagePopupSection(specialInfo[key], this.$store.getters.projectPath)
        break;
      case category === 'Clipboard':
        table += _clipboardPopupSection(specialInfo[key], key)
        break;
      case Array.isArray(specialInfo[key]):
        table += _arrayPopupSection(specialInfo[key], key)
        break;
      case typeof specialInfo[key] === 'object':
        table += _objectPopupSection(specialInfo[key], key)
        break;
      default:
        table += _defaultPopupSection(specialInfo[key], key)
        break;
    }
  })

  table += '</tbody></table>'
  body += table

  if (footer) {
    body += footer
  }
  return body
}

function _imagePopupSection (value, pojectPath) {
  return `
    <tr>
      <td colspan="2">
        <button
          class="popup-img-button"
          image='${value}'
          style="display:inline-block"
        >
          <img
            src="${pojectPath + '/feedback/' + value}"
            alt="can't find an image with name ${value}"
            style="height: 165px; object-fit: cover;"
          />
        </button>
      </td>
    </tr>
  `
}

function _arrayPopupSection (value, key) {
  return `
    <tr>
      <td style="word-wrap: break-word; vertical-align: top">${helpers.methods.formatString(key)}:</td>
      <td class="pl-2" style="word-wrap: break-word">
        ${
          value.map(item => {
            if (typeof item === 'object') {
              return `
                <div class="d-flex justify-space-between">
                  ${Object.keys(item).reduce((all, subkey) => {
                    if (subkey === '_id') return all
                    return all + `<div>${item[subkey]}</div>`
                  },'')}
                </div>
              `
            } else {
              return `<div>${item}</div>`
            }
          }).join('')
        }
      </td>
    <tr>
  `
}

function _objectPopupSection (value, key) {
  return Object.keys(value).reduce((rows, subkey) => {
    rows += `
      <tr>
        <td style="word-wrap: break-word; vertical-align: top">
          ${helpers.methods.formatString(key) + ' | ' + helpers.methods.formatString(subkey)}:
        </td>
        <td class="pl-2" style="word-wrap: break-word">${value[subkey]}</td>
      <tr>
    `
    return rows
  }, '')
}

function _defaultPopupSection (value, key) {
  return `
    <tr>
      <td style="word-wrap: break-word; vertical-align: top">${helpers.methods.formatString(key)}:</td>
      <td class="pl-2" style="word-wrap: break-word">${value}</td>
    <tr>
  `
}

function _clipboardPopupSection (value, key) {
  return `
    <tr>
      <td colspan="2" class="text-center">
        <button
          type="button"
          class="popup-clipboard-button v-btn v-btn--outlined v-btn--rounded theme--light v-size--x-small black--text"
          data="${value}"
        >
          <span class="v-btn__content">
            <span>Copy ${helpers.methods.formatString(key)}</span>
          </span>
        </button>
      </td>
    <tr>
  `
}

export {
  inside,
  specialInfo,
  setPopupWrapper
}